import ClientStorage from '../index';
import isClient from '../../../common/helpers/environment';
import { useLogger } from '../../logger/LoggerProvider';

const useClientStorage = () => {
    const logger = useLogger();

    if (isClient()) {
        try {
            const clientStorage = new ClientStorage(logger);
            return clientStorage;
        } catch (e) {
            logger.warn('clientStorage cannot access client storage', e);
            return null;
        }
    }

    return null;
};

export default useClientStorage;
